import { ReactNode } from "react";

import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";

export const LOCKED_FILTER_TOOLTIP = "Locked by your report permissions";

type FilterChipProps = {
  label: ReactNode;
  onDelete: () => void;
  onClick: () => void;
  /** Pinned by report permissions — cannot be cleared. */
  isLocked?: boolean;
  /** Nothing left to choose, so the picker stays shut. */
  isPinned?: boolean;
};

/**
 * The filter bar's selected-value pill, shared by the dropdown and the standalone filter.
 *
 * A locked pill drops its delete control: clearing it would widen the report back to everything the
 * permission was meant to exclude. The lock icon and tooltip are what explain the missing ✕.
 */
export default function FilterChip({
  label,
  onDelete,
  onClick,
  isLocked = false,
  isPinned = false
}: FilterChipProps) {
  if (!isLocked) {
    return <Chip label={label} onDelete={onDelete} onClick={onClick} />;
  }

  return (
    <Tooltip title={LOCKED_FILTER_TOOLTIP}>
      <Chip
        label={label}
        icon={<LockOutlinedIcon fontSize="small" />}
        // A scope of several clinics still lets the user pick between them; only a filter with
        // nothing left to choose stops opening.
        onClick={isPinned ? undefined : onClick}
        data-testid="locked-filter-chip"
      />
    </Tooltip>
  );
}
